export const SEARCH_INPUT_VALUE = "SEARCH_INPUT_VALUE";
